// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { ShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { StoreListGetShipTosApiParameter } from "@store/Framework/Services/CustomersService";
import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    StoreListGetShipTosApiParameter & HasOnSuccess,
    StoreListGetShipTosApiParameter,
    ShipToCollectionModel
>;

export const StorePopulateAdditionalApiParameter: HandlerType = props => {
    const storeListId = props.getState().store.pages.storeListsDetails.customersParameter.storeListId;
    if (storeListId) {
        props.apiParameter.storeListId = storeListId;
    }
};

addToChainAfter(chain, PopulateApiParameter, StorePopulateAdditionalApiParameter);
